import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { AuthContext } from '../../../contexts/AuthContext';
import PageTitle from '../../../layouts/global/dashboard/PageTitle';
import Sidebar from '../../../layouts/global/dashboard/Sidebar';
import TopHeader from '../../../layouts/global/dashboard/TopHeader';
import AllRewardTransactions from '../../../layouts/global/rewards/AllRewardTransactions';

export default function Notifications() {
  const { state } = useContext(AuthContext);
  const [transactions, setTransactions] = useState([]);
  const token = localStorage.getItem('token');
  const loadTransactions = async () => {
    const response = await axios.get(
      'https://secret-ridge-31139.herokuapp.com/api/airtime-disbursement-report',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    console.log(response.data);
    return setTransactions(response.data);
  };

  useEffect(() => {
    loadTransactions();
  }, []);
  return (
    <div>
      {state.isAuth ? (
        <Redirect to="/dashboard/notifications" />
      ) : (
        <Redirect to="/login" />
      )}
      <main className={'flex flex-col lg:flex-row'}>
        <Sidebar />
        <TopHeader />
        <section className={'lg:w-full bg-gray-100 min-h-screen'}>
          <div
            className={
              'w-full px-5 lg:pl-72 pt-20 lg:pt-16 lg:pr-10 bg-gray-100'
            }
          >
            <PageTitle title={'Delivery Report'} />
            <div className={'p-2'}>
              <div className={'p-5 shadow bg-white w-full mt-5'}>
                <div className={'mb-3'}>
                  <h3 className={'font-medium text-lg text-yellow-500'}>
                    Delivery Report
                  </h3>
                </div>
                {transactions && (
                  <AllRewardTransactions transactions={transactions} />
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
